import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React, { Component } from 'react';
import { browser } from '@atlaskit/editor-common/utils';
import { hoverRows, selectRow } from '../../commands';
import { isSelectionUpdated } from '../../utils';
import { CornerControls } from './CornerControls';
import NumberColumn from './NumberColumn';
import { RowControls } from './RowControls';
var TableFloatingControls = /*#__PURE__*/function (_Component) {
  _inherits(TableFloatingControls, _Component);
  var _super = _createSuper(TableFloatingControls);
  function TableFloatingControls() {
    var _this;
    _classCallCheck(this, TableFloatingControls);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "selectRow", function (row, expand) {
      var editorView = _this.props.editorView;
      var state = editorView.state,
        dispatch = editorView.dispatch;
      // fix for issue ED-4665
      if (browser.ie_version === 11) {
        editorView.dom.blur();
      }
      selectRow(row, expand)(state, dispatch);
    });
    _defineProperty(_assertThisInitialized(_this), "hoverRows", function (rows, danger) {
      var _this$props$editorVie = _this.props.editorView,
        state = _this$props$editorVie.state,
        dispatch = _this$props$editorVie.dispatch;
      hoverRows(rows, danger)(state, dispatch);
    });
    return _this;
  }
  _createClass(TableFloatingControls, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.tryInitResizeObserver();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      // tableRef prop is not guaranteed to be defined after componentDidMount, so retry to init resize observer on update
      this.tryInitResizeObserver();
    }

    // tracking the table height changes to update floating controls
  }, {
    key: "tryInitResizeObserver",
    value: function tryInitResizeObserver() {
      var _window,
        _this2 = this;
      var tableRef = this.props.tableRef;
      var _this$props$getEditor = this.props.getEditorFeatureFlags(),
        tableRenderOptimization = _this$props$getEditor.tableRenderOptimization;
      if (tableRenderOptimization && tableRef && !this.resizeObserver && (_window = window) !== null && _window !== void 0 && _window.ResizeObserver) {
        this.resizeObserver = new ResizeObserver(function (entries) {
          var _iterator = _createForOfIteratorHelper(entries),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var entry = _step.value;
              var tableHeight = entry.contentRect.height;
              _this2.setState({
                tableHeight: tableHeight
              });
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        });
        this.resizeObserver.observe(tableRef);
      }
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      var _this$state;
      var _this$props = this.props,
        tableRef = _this$props.tableRef,
        isInDanger = _this$props.isInDanger,
        isResizing = _this$props.isResizing,
        isHeaderRowEnabled = _this$props.isHeaderRowEnabled,
        isNumberColumnEnabled = _this$props.isNumberColumnEnabled,
        hoveredRows = _this$props.hoveredRows,
        selection = _this$props.selection,
        tableActive = _this$props.tableActive,
        isHeaderColumnEnabled = _this$props.isHeaderColumnEnabled,
        ordering = _this$props.ordering,
        headerRowHeight = _this$props.headerRowHeight,
        stickyHeader = _this$props.stickyHeader;
      var _this$props$getEditor2 = this.props.getEditorFeatureFlags(),
        tableRenderOptimization = _this$props$getEditor2.tableRenderOptimization;
      var tableHeight = tableRenderOptimization ? (_this$state = this.state) === null || _this$state === void 0 ? void 0 : _this$state.tableHeight : this.props.tableHeight;
      var nextTableHeight = tableRenderOptimization ? nextState === null || nextState === void 0 ? void 0 : nextState.tableHeight : nextProps.tableHeight;
      return ordering !== nextProps.ordering || tableRef !== nextProps.tableRef || tableHeight !== nextTableHeight || tableActive !== nextProps.tableActive || isInDanger !== nextProps.isInDanger || isResizing !== nextProps.isResizing || hoveredRows !== nextProps.hoveredRows || isHeaderRowEnabled !== nextProps.isHeaderRowEnabled || isHeaderColumnEnabled !== nextProps.isHeaderColumnEnabled || isNumberColumnEnabled !== nextProps.isNumberColumnEnabled || isSelectionUpdated(selection, nextProps.selection) || headerRowHeight !== nextProps.headerRowHeight || stickyHeader !== nextProps.stickyHeader;
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        editorView = _this$props2.editorView,
        tableRef = _this$props2.tableRef,
        isInDanger = _this$props2.isInDanger,
        isResizing = _this$props2.isResizing,
        isNumberColumnEnabled = _this$props2.isNumberColumnEnabled,
        isHeaderRowEnabled = _this$props2.isHeaderRowEnabled,
        isHeaderColumnEnabled = _this$props2.isHeaderColumnEnabled,
        tableActive = _this$props2.tableActive,
        hasHeaderRow = _this$props2.hasHeaderRow,
        hoveredRows = _this$props2.hoveredRows,
        stickyHeader = _this$props2.stickyHeader;
      if (!tableRef) {
        return null;
      }
      var stickyTop = stickyHeader && stickyHeader.sticky && hasHeaderRow ? stickyHeader.top : undefined;
      return /*#__PURE__*/React.createElement("div", {
        onMouseDown: function onMouseDown(e) {
          return e.preventDefault();
        }
      }, isNumberColumnEnabled ? /*#__PURE__*/React.createElement(NumberColumn, {
        editorView: editorView,
        hoverRows: this.hoverRows,
        tableRef: tableRef,
        tableActive: tableActive,
        hoveredRows: hoveredRows,
        hasHeaderRow: hasHeaderRow,
        isInDanger: isInDanger,
        isResizing: isResizing,
        selectRow: this.selectRow,
        stickyTop: stickyTop
      }) : null, tableActive && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(CornerControls, {
        editorView: editorView,
        tableRef: tableRef,
        isInDanger: isInDanger,
        isResizing: isResizing,
        isHeaderRowEnabled: isHeaderRowEnabled,
        isHeaderColumnEnabled: isHeaderColumnEnabled,
        hoveredRows: hoveredRows,
        stickyTop: tableActive ? stickyTop : undefined
      }), /*#__PURE__*/React.createElement(RowControls, {
        editorView: editorView,
        tableRef: tableRef,
        hoverRows: this.hoverRows,
        hoveredRows: hoveredRows,
        isInDanger: isInDanger,
        isResizing: isResizing,
        selectRow: this.selectRow,
        stickyTop: tableActive ? stickyTop : undefined
      })));
    }
  }]);
  return TableFloatingControls;
}(Component);
_defineProperty(TableFloatingControls, "displayName", 'TableFloatingControls');
export { TableFloatingControls as default };